document.addEventListener('DOMContentLoaded', function() {
    // Handle opening modals
    document.querySelectorAll('.modalbutton').forEach(function(button) {
        button.addEventListener('click', function(event) {
            event.preventDefault(); 
            var modalId = this.getAttribute('href').substring(1); 
            openModal(modalId);
            disableModalButtons(); // Disable modal buttons
        });
    });

  document.querySelectorAll('.popup__close').forEach(function(closeButton) {
        closeButton.addEventListener('click', function(event) {
            event.preventDefault(); // Prevent default anchor behavior
            closeAllModals();
            enableModalButtons(); // Re-enable modal buttons
        });
    });

    // Handle closing modals
    document.addEventListener('click', function(event) {
        if (!event.target.closest('.popup') && !event.target.closest('.modalbutton')) {
            closeAllModals();
            enableModalButtons(); // Enable modal buttons
        }
    });

    // Function to open a modal
    function openModal(modalId) {
        var modal = document.getElementById(modalId);
        if (modal) {
            modal.style.display = 'block'; 
        }
    }

    // Function to close all modals
    function closeAllModals() {
        document.querySelectorAll('.popup').forEach(function(modal) {
            modal.style.display = 'none'; 
        });
    }

    // Disable modal buttons
    function disableModalButtons() {
        document.querySelectorAll('.modalbutton').forEach(function(button) {
            button.style.pointerEvents = 'none';
        });
    }

    // Enable modal buttons
    function enableModalButtons() {
        document.querySelectorAll('.modalbutton').forEach(function(button) {
            button.style.pointerEvents = 'auto';
        });
    }
});